import React from "react";
import { Grid, Typography } from "@mui/material";
import { StyledTextField } from "../../utilities/styles/checkoutPage.style";
import { formatPhoneNumberInput } from "../../utilities/FormatPhoneNumber";

interface ContactInformationSectionProps {
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    classes: any;
    validator: any;
    onChange: (e: any, fieldName: string) => void;
    handlePhone: (e: any) => void;
}

const ContactInformationSection: React.FC<ContactInformationSectionProps> = ({
    firstName,
    lastName,
    email,
    phoneNumber,
    classes,
    validator,
    onChange,
    handlePhone,
}) => {
    return (
        <>
            <Typography
                gutterBottom
                sx={{
                    mt: 4,
                    mb: 2,
                    fontSize: { sm: "20px" },
                    fontWeight: 600,
                }}
            >
                Contact
            </Typography>
            <Grid container spacing={2} direction="row">
                <Grid item xs={12} sm={6}>
                    <StyledTextField
                        autoComplete="given-name"
                        name="firstName"
                        className={classes.marginBottom5}
                        required
                        id="firstName"
                        label="First name"
                        value={firstName}
                        onChange={(e: any) => onChange(e, "firstName")}
                        onBlur={() =>
                            validator.message(
                                "first name",
                                typeof firstName === "string" ? firstName.trim() : firstName,
                                "required|noSpecialChar"
                            )
                        }
                        fullWidth
                        variant="outlined"
                    />
                    {validator.message(
                        "first name",
                        firstName,
                        "required|noSpecialChar"
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <StyledTextField
                        name="lastName"
                        autoComplete="family-name"
                        className={classes.marginBottom5}
                        required
                        id="lastName"
                        value={lastName}
                        onChange={(e: any) => onChange(e, "lastName")}
                        onBlur={() =>
                            validator.message(
                                "last name",
                                typeof lastName === "string" ? lastName.trim() : lastName,
                                "required|noSpecialChar"
                            )
                        }
                        label="Last name"
                        fullWidth
                        variant="outlined"
                    />
                    {validator.message("last name", lastName, "required|noSpecialChar")}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <StyledTextField
                        name="email"
                        autoComplete="email"
                        className={classes.marginBottom5}
                        required
                        id="email"
                        value={email}
                        onChange={(e: any) => onChange(e, "email")}
                        onBlur={() => validator.showMessageFor("email")}
                        label="Email"
                        fullWidth
                        variant="outlined"
                    />
                    {validator.message("email", email, "required|email")}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <StyledTextField
                        name="phoneNumber"
                        autoComplete="tel"
                        className={classes.marginBottom5}
                        required
                        id="phoneNumber"
                        value={formatPhoneNumberInput(phoneNumber)}
                        placeholder="(xxx) xxx-xxxx"
                        onChange={handlePhone}
                        onBlur={() =>
                            validator.message(
                                "phone number",
                                typeof phoneNumber === "string"
                                    ? phoneNumber.trim()
                                    : phoneNumber,
                                "required|phone"
                            )
                        }
                        label="Phone Number"
                        fullWidth
                        variant="outlined"
                    />
                    {validator.message("phone number", phoneNumber, "required|phone")}
                </Grid>
            </Grid>
        </>
    );
};

export default ContactInformationSection;
